export function isEmailValid(email: string): boolean {
  const [user, domain]: Array<string | undefined> = email.split('@');
  const userRegExp: RegExp = /^[-!#$%&'*+/=?^`{}|~\w]+(\.[-!#$%&'*+/=?^`{}|~\w]+)*$|^"([\001-\010\013\014\016-\037!#-\[\]-\177]|\\[\001-\011\013\014\016-\177])*"$/i;  // eslint-disable-line
  const domainRegExp: RegExp = /^(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z]{2,6}|[A-Z0-9-]{2,})$|^\[(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}\]$/i;  // eslint-disable-line

  if (!user || !domain || user.length > 64 || domain.length > 255) {
    return false;
  }

  return userRegExp.test(user) && domainRegExp.test(domain);
}
